import { type Platform } from "../../constants";
import { getNorthbeamUtmPlatformParams } from "../../metadata";

export const UTMParamTable = ({ platform }: { platform: Platform }) => {
  const urlParamPairs = getNorthbeamUtmPlatformParams(platform);
  return (
    <table
      className={`w-full table-striped bg-white
     rounded-lg border-collapse outline outline-1 outline-gray-1
     text-xs leading-none [&_*]:border-gray-2`}
    >
      <thead className="text-xs">
        <tr className="[&>th]:p-2">
          <th className="border-r ">Key</th>
          <th>Value</th>
        </tr>
      </thead>
      <tbody className="[&_td]:p-2 text-sm leading-tight">
        {urlParamPairs.map(({ key, value }) => (
          <tr key={key} className="odd:bg-white even:bg-[#fafafe] border-y ">
            <td className="w-0 whitespace-nowrap border-r">
              <code className="text-venus">{key}</code>
            </td>
            <td>{value}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
